import {createAction} from 'redux-actions'

const action = name => createAction(`storyline-view/${name}`)

export const setStoryIds = action('SET_STORY_IDS')
export const setIsLoading = action('SET_IS_LOADING')
